// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:25
import { CPatientDestinationLocation_abstract } from './../abstract/SagaSchema/CPatientDestinationLocation_abstract';
export class CPatientDestinationLocation extends CPatientDestinationLocation_abstract {}
